import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: {
    search: '',
    paymentStatus: '',
    page: 1,
    limit: 10
  },
  selectedBid: null,
  modalStates: {
    assignDriver: false,
    uploadPod: false,
    deliveryConfirm: false,
    deliverySuccess: false
  }
};

const bidSlice = createSlice({
  name: 'bids',
  initialState,
  reducers: {
    setBidFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setBidPage: (state, action) => {
      state.filters.page = action.payload;
    },
    setSelectedBid: (state, action) => {
      state.selectedBid = action.payload;
    },
    clearSelectedBid: (state) => {
      state.selectedBid = null;
    },
    setModalState: (state, action) => {
      const { modal, isOpen } = action.payload;
      state.modalStates[modal] = isOpen;
    },
    resetFilters: (state) => {
      state.filters = {
        search: '',
        paymentStatus: '',
        page: 1,
        limit: 10
      };
    }
  }
});

export const {
  setBidFilters,
  setBidPage,
  setSelectedBid,
  clearSelectedBid,
  setModalState,
  resetFilters
} = bidSlice.actions;

export default bidSlice.reducer;